import React from "react"
import Switch from "@mui/material/Switch"
import BugReportOutlinedIcon from "@mui/icons-material/BugReportOutlined"

import {useUserContext} from "../../contexts/UserContext"

export const SuperUserSettings = () => {
    // Superuser-only panel. isSuperUser() reads profileState.is_superuser (a
    // boolean, omitted entirely for non-superusers) — never render this for
    // anyone else.
    const { profileState, setProfileStateWithUpdate, isSuperUser } = useUserContext()

    if (!isSuperUser()) return null

    const isDebugEnabled = Boolean(profileState?.should_return_debug_data)

    return (
        <div className={'profile-panel SuperUserSettings'}>
            <div className={'panel-header'}>
                <div className={'panel-title'}>
                    <BugReportOutlinedIcon/>
                    Superuser
                </div>
            </div>
            <div className={'panel-body'}>
                <div className={'setting-row'}>
                    <span className={'setting-row-label'}>Return Debug Data</span>
                    <Switch
                        size={'small'}
                        checked={isDebugEnabled}
                        onChange={() => setProfileStateWithUpdate({
                            should_return_debug_data: !isDebugEnabled,
                        })}
                        inputProps={{'aria-label': 'Return debug data'}}
                    />
                </div>
            </div>
        </div>
    )
}
